import * as React from "react";
const SvgCalendar24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 22,
        fill: "black",
        viewBox: "0 0 20 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M5.5 7.5V5H2v4h16V5h-3.5v2.5h-2V5h-5v2.5h-2Zm7-4.5h-5V.5h-2V3H0v19h20V3h-5.5V.5h-2V3Zm5.5 8H2v9h16v-9Z",
      clipRule: "evenodd"
    })
  );
export default SvgCalendar24Px;
